import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import locale from 'element-plus/es/locale/lang/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.less'
import '@/assets/icon-font/iconfont.css'
import myPagination from '@/components/my-pagination/index'
import lodash from 'lodash'
import htmlToPdf from '@/utils/htmlToPdf'
import 'default-passive-events';
import {ElMessage} from 'element-plus'
// 【临时探针】验证 ops-api 代理是否生效，验证完成后可删除本行及以下 window.requestOps 挂载
import { requestOps } from '@/utils/request'

// 将所有ui组件全局注册
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 全局注册分页组件
app.component('myPagination',myPagination)
app.config.globalProperties.$lodash = lodash;
app.config.globalProperties.htmlToPdf = htmlToPdf;
app.config.globalProperties.$ElMessage = ElMessage;

// 全局挂载

// 导入全局组件
// import XtxSkeleton from '@/components/Skeleton'
// 导入全局指令
// import DirectivesPlugin from '@/directives'

// createApp(App)
// // .use(XtxSkeleton)
// // .use(DirectivesPlugin)
// .use(router)
// .use(store)
// .use(ElementPlus)
// .mount('#app')
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

app.use(router)
app.use(store)
app.use(ElementPlus, { locale});
// 【临时探针】验证 ops-api 代理：在浏览器 Console 可调用 window.requestOps.get('/rl/music/list')
window.requestOps = requestOps;
app.mount('#app');

